'use client';
export const defaultPageSize = 25;
